import { MediaObject } from "../types/MediaObject";

const MERGE_RESTRICTION_LABELS: Record<Exclude<MediaObject["mergeRestriction"], null>, string> = {
  unsupportedFormat: "Format derzeit nicht unterstützt",
  encrypted: "Passwortgeschützte PDFs werden nicht unterstützt",
  unreadable: "Datei ist als nicht lesbar markiert",
};

export const getMediaObjectMergeRestrictionLabel = (mergeRestriction: MediaObject["mergeRestriction"]) => {
  return mergeRestriction === null ? null : MERGE_RESTRICTION_LABELS[mergeRestriction];
};

export const toggleMediaObjectSelection = (selectedMediaObjectIds: number[], mediaObjectId: number) => {
  return selectedMediaObjectIds.includes(mediaObjectId)
    ? selectedMediaObjectIds.filter((selectedMediaObjectId) => selectedMediaObjectId !== mediaObjectId)
    : [...selectedMediaObjectIds, mediaObjectId];
};

export const reorderMediaObjectIds = (mediaObjectIds: number[], sourceIndex: number, destinationIndex: number) => {
  const reorderedMediaObjectIds = [...mediaObjectIds];
  const [movedMediaObjectId] = reorderedMediaObjectIds.splice(sourceIndex, 1);
  reorderedMediaObjectIds.splice(destinationIndex, 0, movedMediaObjectId);

  return reorderedMediaObjectIds;
};
